import React from "react";
import * as styles from "./velavu-notice-header.module.scss";

export interface VelavuNoticeHeaderProps {
	children?: React.ReactNode;
}

export default function VelavuNoticeHeader(props: VelavuNoticeHeaderProps) {
	return <h4 className={styles.header}>{props.children}</h4>;
}
